// Freight weights and dimensions are DECIMAL(12,3) in the database. These helpers
// coerce whatever the API sends (number or string) and round to 3 places so summed
// values don't pick up floating point artifacts.

export const toNumber = (value?: number | string | null): number => {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

// Rounds to 3 decimal places and drops trailing zeros: 48.000 -> "48", 10.500 -> "10.5"
export const formatDecimal = (value?: number | string | null): string =>
  String(Number(toNumber(value).toFixed(3)));

// Same, but returns null for missing or zero values so callers can fall back to 'N/A'
export const formatDecimalOrNull = (value?: number | string | null): string | null => {
  const num = Number(toNumber(value).toFixed(3));
  return num === 0 ? null : String(num);
};
